
import CustomButton from '../components/CustomButton/CustomButton';

const NotFound = () => {
    const awsImageBaseUrl = process.env.REACT_APP_AWS_IMAGE_BUCKET_URL; 
  return (
        <section>
            <div className="card text-white border-0 hero-card ">
                {/* Responsive image wrapper with fixed height */}
                <div className="card-img-wrapper">
                    <img src={`${awsImageBaseUrl}images/404.jpg`}  className="card-img rounded-0" alt="Hero Background" />
                </div>
                {/* Overlay Content */}
                <div className="card-img-overlay d-flex flex-column justify-content-center align-items-center text-center hero-overlay">
                    <h1 className="font-bold  display-5 mb-4 text-shadow text-uppercase">
                        This is not the page you are looking for
                    </h1>
                    <h2 className="font-bold  text-2xl mb-4">
                        Try going back to our homepage</h2>
                    <div className="row justify-content-center g-3">
                        <div className="col-auto">
                            <CustomButton
                                label="Return Home"
                                variant="red"
                                size="small"
                                href="/"
                                target=""
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
}

export default NotFound;
